import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './services/i18n' // Initialize i18n
import './utils/patchScrollTo' // Redirect window.scrollTo to <main> (the real scroll container)
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary'
import { setupDataDog } from './utils/datadog'
import { setupThirdPartyErrorFiltering } from './utils/handle-third-party-errors'
import { invalidateCacheIfNewBuild } from './utils/cacheInvalidation'
import { logger } from './utils/logger'

// Initialize DataDog and third-party error filtering before rendering
async function initializeApp() {
  try {
    // Clear persisted stores if a new build was deployed
    invalidateCacheIfNewBuild();

    // Setup DataDog logging (only if token is configured)
    await setupDataDog();

    // Setup third-party error filtering (Google Analytics, Facebook, etc.)
    setupThirdPartyErrorFiltering();

    // Expose logger globally for browser console testing
    (window as any).logger = logger;

    console.info('[Claims Portal] App initialization complete');
  } catch (error) {
    console.error('[Claims Portal] Failed to initialize app:', error);
    // Continue rendering even if DataDog setup fails
  }

  // Render the app
  createRoot(document.getElementById('root')!).render(
    // StrictMode disabled to prevent double API calls in development
    // Re-enable before production build to catch potential issues
    // <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    // </StrictMode>,
  );
}

// Start the app
initializeApp();